import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  NavLink as RouterLink,
  matchPath,
  useLocation,
} from 'react-router-dom';

// mui
import { makeStyles } from '@mui/styles';
import {
  Collapse, List, ListItemIcon, ListItemText, Typography, Box, ListItemButton, ListItem, Button,
} from '@mui/material';

// project imports

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import NavItem from './NavItem';

// style constant
const useStyles = makeStyles((theme) => ({
  collapseIcon: {
    fontSize: '1rem',
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  collapseIconSub: {
    fontSize: '1rem',
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  menuIcon: {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  listIcon: {
    minWidth: '18px',
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  listCustomIconSub: {
    width: '6px',
    height: '6px',
  },
  listCustomIconSubActive: {
    width: '8px',
    height: '8px',
  },
  listItem: {
    marginBottom: '5px',
    alignItems: 'flex-start',
  },
  listItemNoBack: {
    marginBottom: '5px',
    backgroundColor: 'transparent !important',
    paddingTop: '8px',
    paddingBottom: '8px',
    alignItems: 'flex-start',
  },
  subMenuCaption: {
    ...theme.typography.subMenuCaption,
  },
  collapseWrapper: {
    position: 'relative',
    '&:after': {
      content: "''",
      position: 'absolute',
      left: '32px',
      top: 0,
      height: '100%',
      width: '1px',
      opacity: 1,
      background: theme.palette.primary.light,
    },
  },
}));

// -----------------------|| SIDEBAR MENU LIST COLLAPSE ITEMS ||-----------------------//

function NavGroupItem({ menu, level }) {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState(null);

  const handleClick = () => {
    setOpen(!open);
    setSelected(!selected ? menu.id : null);
  };

  const location = useLocation();

  const active = menu.url ? !!matchPath({
    path: menu.url,
    end: false,
  }, location.pathname) : false;

  // menu collapse & item
  const menus = menu.children.map((item) => {
    switch (item.type) {
      case 'single':
        return (
          <Box key={item.id} sx={{ marginLeft: 4 }}>
            <NavItem
              href={item.url}
              title={item.title}
              icon={item.icon}
            />
          </Box>
        );
      default:
        return (
          <Typography
            key={item.id}
            variant="h6"
            color="error"
            align="center"
          >
            Menu Items Error
          </Typography>
        );
    }
  });

  const Icon = menu.icon;

  return (
    <Box>
      <ListItem
        disableGutters
        sx={{
          display: 'flex',
          py: 0,
        }}
      >
        <Button
          component={RouterLink}
          sx={{
            color: 'text.secondary',
            fontWeight: 'medium',
            justifyContent: 'flex-start',
            letterSpacing: 0,
            py: 1.25,
            textTransform: 'none',
            width: '100%',
            ...(active && {
              color: 'primary.main',
            }),
            '& svg': {
              mr: 1,
            },
          }}
          onClick={handleClick}
        >
          {Icon && (
          <Icon size="20" />
          )}
          <span>
            {menu.title}
          </span>

          <Box sx={{
            margin: 'auto auto',
          }}
          >
            {open ? (
              <IconChevronUp stroke={1.5} size="1rem" className={level > 1 ? classes.collapseIconSub : classes.collapseIcon} />
            ) : (
              <IconChevronDown stroke={1.5} size="1rem" className={level > 1 ? classes.collapseIconSub : classes.collapseIcon} />
            )}
          </Box>

        </Button>

      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div">
          {menus}
        </List>
      </Collapse>
    </Box>
  );
}

NavGroupItem.propTypes = {
  menu: PropTypes.object,
  level: PropTypes.number,
};

export default NavGroupItem;
